<template>
  <div role="dialog" aria-modal="true">
    <!-- Trigger Button -->
    <button
      @click="openModal"
      class="text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200"
      data-testid="forgotpassword-trigger"
    >
      {{ title }}
    </button>

    <!-- Forgot Password Modal -->
    <Modal :show="isOpen" @close="closeModal" :title="title" size="md" data-testid="forgotpassword-modal">
      <form ref="changepassform" @keyup.enter="Go" class="space-y-6" data-testid="forgotpassword-form">
        <!-- Email Input -->
        <Input
          ref="emailInput"
          v-model="emailaddress"
          label="* School Email"
          type="email"
          required
          autocomplete="email"
          @keydown.shift.tab.prevent="handleShiftTab"
          data-testid="forgotpassword-email-input"
        />

        <!-- Required Field Note -->
        <p class="text-sm text-gray-600">* Required field</p>

        <!-- Response Message -->
        <div v-if="responseMessage" class="text-sm text-center" :class="responseMessage.includes('check your email') ? 'text-green-600' : 'text-red-600'">
          {{ responseMessage }}
        </div>

        <!-- Action Buttons -->
        <div class="flex gap-3 pt-4">
          <Button
            ref="goButton"
            @click="Go"
            variant="primary"
            size="md"
            custom-class="flex-1"
            type="button"
            data-testid="forgotpassword-submit-button"
          >
            Forgot Password
          </Button>
          <Button
            ref="cancelButton"
            @click="closeModal"
            variant="outline"
            size="md"
            custom-class="flex-1"
            type="button"
            @keydown.tab.prevent="handleTab"
            data-testid="forgotpassword-cancel-button"
          >
            Cancel
          </Button>
        </div>
      </form>
    </Modal>
  </div>
</template>

<script>
import logger from '@/utils/logger'
import datamethods from '../../services/datamethods.js'
import Button from '../ui/Button.vue'
import Input from '../ui/Input.vue'
import Modal from '../ui/Modal.vue'

export default {
  name: 'forgotpassword',
  components: {
    Button,
    Input,
    Modal
  },
  props: {
    title: {
      type: String,
      default: 'Forgot Password'
    },
    username: {
      type: String
    }
  },
  mixins: [datamethods],
  data() {
    return {
      isOpen: false,
      emailaddress: '',
      responseMessage: null
    }
  },
  methods: {
    handleTab(event) {
      logger.debug('tab on cancel button')
      event.preventDefault()
      this.$nextTick(() => {
        if (this.$refs.emailInput && this.$refs.emailInput.$el) {
          const input = this.$refs.emailInput.$el.querySelector('input')
          if (input) input.focus()
        }
      })
    },
    handleShiftTab(event) {
      logger.debug('shifttab on email input')
      event.preventDefault()
      this.$nextTick(() => {
        if (this.$refs.cancelButton && this.$refs.cancelButton.$el) {
          this.$refs.cancelButton.$el.focus()
        }
      })
    },
    openModal() {
      this.emailaddress = this.username || ''
      this.responseMessage = null
      this.isOpen = true
      this.$nextTick(() => {
        if (this.$refs.emailInput && this.$refs.emailInput.$el) {
          const input = this.$refs.emailInput.$el.querySelector('input')
          if (input) input.focus()
        }
      })
    },
    closeModal() {
      this.isOpen = false
      this.emailaddress = ''
      this.responseMessage = null
    },
    Go() {
      this.$emit('go', this.emailaddress)
      this.closeModal()
    },
    // Public method for parent components to call
    Forgot() {
      this.openModal()
    }
  }
}
</script>
